import { Box, styled } from '@mui/material'

export const TagOptionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}))

export const TagColorIndicator = styled(Box)(() => ({
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  flexShrink: 0
}))

export const CreateNewTagOption = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  cursor: 'pointer',
  borderTop: `1px solid ${theme.palette.divider}`,
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}))
